// ══════════════════════════════════════════════════════════════════════════════════════════════
//  EL MÓDULO DE RADIOLOGÍA EN EL NAVEGADOR (1-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Lo enciende Biango clínica a clínica desde Superadmin (backend/services/radiologiaModulo). Donde está apagado, el
//  servidor lo dice en los permisos que llegan al navegador: 'radiologia' en `_sistemas_apagados` y `ver_imagenes` a NO
//  (con eso ya no sale la pestaña «Imágenes» de la ficha, pages/Pacientes.jsx). Este fichero es lo que mira lo demás:
//   · `radiologiaEncendida(perms)`: SOLO cuando la respuesta ya ha llegado y no lo nombra. Mientras carga, no: mejor
//     que una entrada aparezca un instante tarde que enseñarla y quitarla (el menú de Administración, AdminLayout.jsx).
//   · `RUTAS_RADIOLOGIA`: las pantallas de Administración que son del módulo.
//   · `SoloConRadiologia`: la puerta de esas rutas (App.jsx). Cargando, nada; apagado, al inicio.
//  El servidor contesta 404 RADIOLOGIA_APAGADA por su cuenta: esconder aquí no es la seguridad, es no enseñar lo que no hay.
import { Navigate } from 'react-router-dom'
import { usePermisos } from '../hooks/usePermisos'

export const RUTAS_RADIOLOGIA = ['/equipos-radiologia', '/imagenes-sin-asignar']

export function radiologiaEncendida(perms) {
  return Array.isArray(perms?._sistemas_apagados) && !perms._sistemas_apagados.includes('radiologia')
}

export default function SoloConRadiologia({ children }) {
  const { perms, permisosListos } = usePermisos()
  if (radiologiaEncendida(perms)) return children
  if (!permisosListos) return null
  return <Navigate to="/" replace />
}
